const R = (typeof window!=='undefined' && window.React) || {};
const Fragment = R.Fragment || 'div';
const createElement = typeof R.createElement === 'function' ? R.createElement.bind(R) : null;
function normalizeProps(props, key){
  if (key !== undefined && key !== null) {
    props = props && typeof props === 'object' ? { ...props, key } : { key };
  }
  return props || {};
}
function jsx(type, props, key){
  if (!createElement) return null;
  return createElement(type, normalizeProps(props, key));
}
const jsxs = jsx;
const jsxDEV = jsx;
export { jsx, jsxs, jsxDEV, Fragment };
export default { jsx, jsxs, jsxDEV, Fragment };
